/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ServeFunctionSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ServeFunctionRequest = {
  /**
   * The ID of the asset to serve
   */
  id: string;
  /**
   * The procect ID that the asset belongs to
   */
  projectId: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ServeFunctionResponse = {
  headers: { [k: string]: Array<string> };
  result: ReadableStream<Uint8Array>;
};

/** @internal */
export type ServeFunctionSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ServeFunctionSecurity$outboundSchema: z.ZodMiniType<
  ServeFunctionSecurity$Outbound,
  ServeFunctionSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function serveFunctionSecurityToJSON(
  serveFunctionSecurity: ServeFunctionSecurity,
): string {
  return JSON.stringify(
    ServeFunctionSecurity$outboundSchema.parse(serveFunctionSecurity),
  );
}

/** @internal */
export type ServeFunctionRequest$Outbound = {
  id: string;
  project_id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ServeFunctionRequest$outboundSchema: z.ZodMiniType<
  ServeFunctionRequest$Outbound,
  ServeFunctionRequest
> = z.pipe(
  z.object({
    id: z.string(),
    projectId: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function serveFunctionRequestToJSON(
  serveFunctionRequest: ServeFunctionRequest,
): string {
  return JSON.stringify(
    ServeFunctionRequest$outboundSchema.parse(serveFunctionRequest),
  );
}

/** @internal */
export const ServeFunctionResponse$inboundSchema: z.ZodMiniType<
  ServeFunctionResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: z.custom<ReadableStream<Uint8Array>>(x =>
      x instanceof ReadableStream
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function serveFunctionResponseFromJSON(
  jsonString: string,
): SafeParseResult<ServeFunctionResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServeFunctionResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServeFunctionResponse' from JSON`,
  );
}
